import request from '@/util/request'

// 赛事账号列表
export const listByCompetitionId = (id) => {
  return request({
    url: `/api/register/competition/user/listByCompetitionId/${id}`,
    method: 'GET'
  })
}
